import { useRef } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useSearchUsers = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook({ items: [] });
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const abortRef = useRef(null);

  const searchUsers = async ({ q, limit = 10, signal } = {}) => {
    abortRef.current?.abort();
    const localController = new AbortController();
    abortRef.current = localController;

    const params = new URLSearchParams();
    if (q != null) params.set("q", q);
    params.set("limit", String(limit));

    startLoading();
    const url = `/users/search?${params.toString()}`;
    const errMsg = "Error al buscar usuarios";

    try {
      const resp = (await apiGet(url, errMsg, { signal: signal ?? localController.signal })) || { items: [] };
      setResponse(resp);
      return resp?.data ? resp.data : resp;
    } finally {
      if (abortRef.current === localController) abortRef.current = null;
    }
  };

  const abort = () => abortRef.current?.abort();

  return { searchUsers, abort, data, error, loading };
};

export default useSearchUsers;
